// Some third-party app embeds (Easify Product Options, Judge.me reviews, etc.)
// insert <img> tags pointing at raw cdn.shopify.com/s/files/... URLs with no
// width param. Shopify Files serves those at full resolution (hundreds of KB
// per swatch / review thumbnail). This script appends Shopify image-transform
// query params so the same files are delivered as ~30 KB WebP. Theme-owned
// images already go through the image_url filter and resolve to the
// chickencraft.co.uk storefront CDN, so they do not match this regex.
(function () {
  'use strict';

  var RAW_FILE_URL = /^https:\/\/cdn\.shopify\.com\/s\/files\/.+\.(png|jpe?g|gif|webp)(\?.*)?$/i;
  var TARGET_WIDTH = '600';
  var TARGET_FORMAT = 'webp';
  var TARGET_QUALITY = '85';

  function rewriteUrl(url) {
    try {
      var u = new URL(url);
      if (u.searchParams.has('width')) return null;
      u.searchParams.set('width', TARGET_WIDTH);
      u.searchParams.set('format', TARGET_FORMAT);
      u.searchParams.set('quality', TARGET_QUALITY);
      return u.toString();
    } catch (e) {
      return null;
    }
  }

  function processImage(img) {
    if (img.dataset.ccImageShrunk === '1') return;
    var src = img.getAttribute('src');
    if (!src || !RAW_FILE_URL.test(src)) return;
    var next = rewriteUrl(src);
    if (!next || next === src) return;
    img.dataset.ccImageShrunk = '1';
    img.setAttribute('src', next);
    var srcset = img.getAttribute('srcset');
    if (srcset) {
      var rewroteAny = false;
      var nextSrcset = srcset.split(',').map(function (part) {
        var trimmed = part.trim();
        var match = trimmed.match(/^(\S+)(\s+\S+)?$/);
        if (!match) return part;
        var rewritten = rewriteUrl(match[1]);
        if (!rewritten) return part;
        rewroteAny = true;
        return rewritten + (match[2] || '');
      }).join(', ');
      if (rewroteAny) img.setAttribute('srcset', nextSrcset);
    }
  }

  function processAll() {
    var imgs = document.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i += 1) processImage(imgs[i]);
  }

  var pending = false;
  function scheduleScan() {
    if (pending) return;
    pending = true;
    var run = function () { pending = false; processAll(); };
    if (typeof window.requestAnimationFrame === 'function') {
      window.requestAnimationFrame(run);
    } else {
      window.setTimeout(run, 0);
    }
  }

  function nodeIsRelevant(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.tagName === 'IMG') return true;
    if (typeof node.querySelector === 'function' && node.querySelector('img')) return true;
    return false;
  }

  function start() {
    processAll();
    if (typeof window.MutationObserver !== 'function') return;
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        var m = mutations[i];
        if (m.type === 'attributes') {
          if (m.target && m.target.tagName === 'IMG') {
            scheduleScan();
            return;
          }
          continue;
        }
        for (var j = 0; j < m.addedNodes.length; j += 1) {
          if (nodeIsRelevant(m.addedNodes[j])) {
            scheduleScan();
            return;
          }
        }
      }
    });
    observer.observe(document.body, {
      attributeFilter: ['src', 'srcset'],
      attributes: true,
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
